<section id="policies" class="py-5 bg-light" appScrollReveal>
  <div class="container">
    <h2 class="section-title">Policies</h2>
    <div class="row g-4">
      <div class="col-md-6">
        <div class="p-4 bg-white rounded shadow-sm h-100 small">
          <h5 class="fw-semibold">Consent & Privacy</h5>
          <p>By submitting your information, you consent to being contacted for appointment scheduling and follow-up care. Your data will never be used for marketing or shared with third parties.</p>
          <h6 class="fw-semibold">Data Usage</h6>
          <ul class="ps-3 mb-0">
            <li>Used only for clinical communication.</li>
            <li>Secure storage practices intended.</li>
            <li>No third-party selling.</li>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <div class="p-4 bg-white rounded shadow-sm h-100 small">
          <h5 class="fw-semibold">Disclaimer</h5>
          <p>This website provides general medical information and appointment booking support. It is not a substitute for emergency care.</p>
          <p class="mb-0"><em>In emergencies, please visit the nearest emergency department.</em></p>
        </div>
      </div>
    </div>
  </div>
</section>
